import { render, staticRenderFns } from "./veStuGraduationYxbys.vue?vue&type=template&id=61409255&scoped=true"
import script from "./veStuGraduationYxbys.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYxbys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61409255",
  null
  
)

export default component.exports